export default "__VITE_ASSET__2TgBeU9A__"